/**
 * @generated SignedSource<<83109d44b81dc1000015ea5baf111d70>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LessonTypeSelect_staffProfile$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"useGetLessonTypeOptions_staffProfile">;
  readonly " $fragmentType": "LessonTypeSelect_staffProfile";
};
export type LessonTypeSelect_staffProfile$key = {
  readonly " $data"?: LessonTypeSelect_staffProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"LessonTypeSelect_staffProfile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LessonTypeSelect_staffProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetLessonTypeOptions_staffProfile"
    }
  ],
  "type": "StaffProfile",
  "abstractKey": null
};

(node as any).hash = "22578021e62d2d6338d5a1387c20a94a";

export default node;
